import { LogErrors } from './../../LogErrors'

import { GetLearningInstrumentsInstructors as DLGetLearningInstrumentsInstructors, GetActivityInstructors as DLGetActivityInstructors } from './../../DL/Instructor/Instruments'

import { UpdateSessionInfo } from './../Sessions'


const GetLearningInstrumentsInstructors = async (session) => {
    try {
        if ((session.navigation === undefined || session.navigation === null) || (session.navigation.course === undefined || session.navigation.course === null) || (session.navigation.instrument === undefined || session.navigation.instrument === null)) {
            // Mostrar mensaje de que no se pudo obtener el contenido del instrumento a mostrar
            return { success: false, message: '' }
        }

        //Validar que exista la info del usuario en el session storage
        if (!sessionStorage.getItem('userData')) {
            return { success: false, message: '' } //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
        }
    
        //Obtener la info del usuario desde el session storage
        const userData = JSON.parse(sessionStorage.getItem('userData'))

        //Comprobar varias propiedades para ver si está correcta la info del usuario
        if (userData.navigation === undefined || userData.navigation === null) {
            return { success: false, message: '' } //Mensaje indicando que su sesión ha expirado.
        }
        
        
        const enabled = userData?.navigation?.instrument?.enabled
        if (!enabled) {
            return { success: true, data: null }
        }

        
        let response
        
        if (userData.navigation.instrument.type === 1) {
            //response = await DLGetLearningInstruments(session.token, session.navigation)
        } else if (userData.navigation.instrument.type === 2) {    
            response = await DLGetLearningInstrumentsInstructors(session.token, session.navigation)
        } else if (userData.navigation.instrument.type === 3) {
            response = await DLGetActivityInstructors(session.token, session.navigation)
        }
        
        if (response.success) {
            // Quitar el acceso rápido o directo al instrumento aprendizaje o evaluación
            if (userData.navigation.course.goToQuickAccessInstrument) {
                userData.navigation.course.goToQuickAccessInstrument = false
                
                await UpdateSessionInfo(userData)
            }
            
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('GetLearningInstrumentsInstructors - BL Instruments Instructors', error)
        return { success: false, message: '' }
    }
}

export { GetLearningInstrumentsInstructors };